import React from 'react';
import { Tooltip as WSRTooltip } from '@wix/design-system';
import { TooltipProps } from '.';

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  disabled,
}) => {
  return (
    <WSRTooltip
      content={content}
      disabled={disabled}
      maxWidth="224px"
      placement="right"
    >
      {children}
    </WSRTooltip>
  );
};
